const firstGreen = "#01bca6";
export const firstGreenLight = firstGreen;
export const firstGreenDark = firstGreen;
export const secondGreenLight = "#ccf4ef";
export const secondGreenDark = "#102724";
export const firstFaceLight = "rgba(0, 0, 0, 0.87)";
export const firstFaceDark = "#fefffe";
export const firstYellow = "#d1b876";
